module.exports = __webpack_public_path__ + "img/bg-5@2x.f0ede77b.png";